<template>
  <div class="l-edit-dialog-box" style="padding-top:0">
    <el-form :model="form_data" label-width="120px" ref="form" :rules="rules" label-position="top" v-loading="loading">
      <!-- <el-divider content-position="left">基础信息</el-divider> -->
      <el-row :gutter="50" style="margin-left:0;margin-right:0">

        <el-col :span="12">
          <el-form-item label="用户名" prop="username">
            <el-input v-model="form_data.username" autocomplete="off" placeholder="请输入用户名" :disabled="isInfo"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="姓名" prop="name">
            <el-input v-model="form_data.name" autocomplete="off" placeholder="请输入姓名" :disabled="isInfo"></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="角色权限" prop="role_ids">
            <el-select v-model="form_data.role_ids" placeholder="请选择当前权限" :disabled="role_list.length == 0 || isInfo"
              @change="role_changes">
              <el-option v-for="item in role_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        
        <el-col :span="12" v-if="role_id_type == 1 ">
          <el-form-item label="管理公司（可多选） 不选默认全部 " prop="corp_ids">
            <el-select v-model="form_data.corp_ids" multiple placeholder="请选择公司(可多选)"
              :disabled=" isInfo || form_data.role_ids == ''">
              <el-option v-for="item in corp_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12" v-if="role_id_type == 1 ">
          <el-form-item label="管理部门（可多选） 不选默认全部" prop="depart_ids">
            <el-select v-model="form_data.depart_ids" multiple placeholder="请选择部门(可多选)"
              :disabled="isInfo || form_data.role_ids == ''">
              <el-option v-for="item in depart_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>


        <el-col :span="12" v-if="role_id_type == 1 ">
          <el-form-item label="管理组（可多选） 不选默认全部" prop="group_ids">
            <el-select v-model="form_data.group_ids" multiple placeholder="请选择管理组(可多选)"
              :disabled="isInfo || form_data.role_ids == ''">
              <el-option v-for="item in group_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>



        <el-col :span="12" v-if="role_id_type != 1">
          <el-form-item label="归属公司（直接默认）根据等级默认" prop="corp_pid">
            <el-select v-model="form_data.corp_pid" placeholder="请选择归属公司"
              :disabled=" isInfo || this.code == 300 || this.code == 400" @change="getdepartList">
              <!-- ||role_id_type == 3 || role_id_type == 4 || role_id_type == 5 -->
              <el-option v-for="item in corp_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>



        <el-col :span="12" v-if="role_id_type != 1 && role_id_type != 2">
          <el-form-item label="归属部门 （直接默认）根据等级默认" prop="depart_pid">
            <el-select v-model="form_data.depart_pid" placeholder="请选择归属部门"
              :disabled=" isInfo || this.code == 400 || this.code == 300" @change="getgroupList">
               <!-- role_id_type == 4 || role_id_type == 5 -->
              <el-option v-for="item in depart_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>


        <el-col :span="12" v-if="role_id_type != 1 && role_id_type != 2 && role_id_type != 3">
          <el-form-item label="归属组名 （直接默认）根据等级默认" prop="group_pid">
            <el-select v-model="form_data.group_pid" placeholder="请选择归属组名"
              :disabled=" isInfo  || this.code == 400 " >
              <!-- || role_id_type == 5 -->
             
              <el-option v-for="item in group_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="管理app （可多选） 不选默认全部" prop="app_ids">
            <el-select v-model="form_data.app_ids" multiple placeholder="请选管理app (可多选)"
              :disabled="app_list.length == 0 || isInfo">
              <el-option v-for="item in app_list" :value="item.id" :label="item.name" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-form-item label="提成模式" prop="commission_model">
            <el-radio-group v-model="form_data.commission_model">
              <el-radio :label="1">CPA</el-radio>
              <el-radio :label="2">CPS</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <template v-if="!isInfo">
            <el-form-item label="密码" prop="pwd">
              <el-row :gutter="50">
                <el-col :span="12">
                  <el-input :type="form_data.pwd == '#none#' ? 'pwd' : 'text'" v-model="form_data.pwd" autocomplete="off"
                    placeholder="请输入登录密码">
                  </el-input>
                </el-col>
                <el-col :span="12">
                  <el-button type="primary" @click="randomWord">生成密码</el-button>
                  <el-button type="success" :disabled="!form_data.pwd || form_data.pwd == '#none#'"
                    v-clipboard:copy="form_data.pwd" v-clipboard:success="copy">复制密码</el-button>
                </el-col>
              </el-row>
            </el-form-item>
          </template>
        </el-col>

        <el-col :span="24">
          <el-form-item label="备注" prop="remark">
            <el-input type="textarea" v-model="form_data.remark" autocomplete="off" :rows="4" maxlength="250"
              :disabled="isInfo" placeholder="请输入备注" show-word-limit></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="24">
          <el-form-item label="状态" prop="state">
            <el-switch v-model="form_data.state" :active-value="1" :inactive-value="0" :disabled="isInfo"
              active-text="启用状态">
            </el-switch>
          </el-form-item>
        </el-col>

      </el-row>
    </el-form>
    <div class="l-dialog-footer">
      <el-button @click="cancel">取 消</el-button>
      <el-button type="primary" @click="handleSubmit" :loading="submitting">确 定</el-button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import { randomWord } from "@/utils/Fuc";
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard);
export default {
  name: "l-user-edit",
  props: {
    id: {
      type: [Number, String],
      default: null,
    },
    visible: {
      type: Boolean,
    },
    org_id: {
      type: [Number, String],
      default: null,
    },
    isInfo: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasId() {
      return this.$props.id !== null;
    },
  },
  data() {
    return {
      loading: false, //页面是否加载中
      code : 100 , 
      show_org_id_select: false,
      role_id_type: '',
      // org_tree: [],
      role_list: [],
      corp_list: [],
      depart_list: [],
      group_list: [],
      app_list: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      //表单数据
      form_data: {
        name: "",
        state: 1,
        pwd: "",
        re_pwd: "",
        remark: "",
        depart_ids: '',
        group_ids: '',
        corp_ids: '',
        depart_pid: "",
        group_pid: "",
        corp_pid: "",
        commission_model: 1,
        role_ids: "",
        role_id: "",
        username: "",
        app_ids: '',
        org_id: ''
      },
      //表单验证规则
      rules: {
        username: [
          {
            required: true,
            message: "请输入用户名",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "姓名不能为空",
            trigger: "change",
          },
        ],
        role_ids: [
          {
            required: true,
            message: "请选择职位",
            trigger: "change",
          },
        ],

        pwd: [
          {
            required: true,
            message: "请输入登录密码",
            trigger: "change",
          },
        ],

        state: [
          {
            type: "number",
            required: true,
            message: "请选择状态",
            trigger: "change",
          },
        ],


      },
      //提交按钮是否显示加载中
      submitting: false,
    };
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        if (val) {
          this.form_data.org_id = this.$props.org_id;
          this.getData();
        }
      },
    },
  },

  methods: {
    // 点击部门获取小组 
    getgroupList(){
      this.$_invoke("adminUser_getBaseList", {
        id: this.form_data.depart_pid,
        type : 4
      })
        .then((ret) => {
          this.group_list = ret;
          this.form_data.group_pid = ""; 
        })
    },
    // 点击公司获取部门 
    getdepartList(){
      this.$_invoke("adminUser_getBaseList", {
        id: this.form_data.corp_pid,
        type : 3
      })
        .then((ret) => {
          this.form_data.group_pid = ""; 
          this.form_data.depart_pid = ""; 
          this.depart_list = ret;
          this.group_list = [];
        })
    },
    // 最高系统员才有的数据
    role_changes(data) {
      this.role_list.filter(i => {
        if (i.id === data) {
          this.role_id_type = i.type
        }
      })
      this.getData_s();
    },
    // 获取
    getData_s() {
      this.$_invoke("adminUser_getAddDataNew", {
        org_id: this.$props.org_id,
        type: this.role_id_type
      })
        .then((ret) => {
          console.log(ret)
          this.corp_list = ret.corp_list;
          this.depart_list = ret.depart_list;
          this.group_list = ret.group_list;
          this.code = ret.code;
          if(ret.code == 300){
           this.form_data.corp_pid = ret.corp_list[0].id;
           this.form_data.depart_pid = ret.depart_list[0].id
          }else if(ret.code == 400){
            this.form_data.corp_pid = ret.corp_list[0].id ;
            this.form_data.depart_pid = ret.depart_list[0].id
            this.form_data.group_pid = ret.group_list[0].id
           
          }

          
        })
    },
    //点击取消通知父组件关闭对话框
    cancel() {
      this.$emit("update:visible", false);
    },

    changes() {
      this.$_invoke("adminUser_streetGetCommunity", {
        pid_ids: this.form_data.street_ids
      }).then((ret) => {
        // console.log(ret)
        this.community_list = ret.community_list;
      })
        .finally(() => {
          this.loading = false;
        });
    },

    changes_street() {
      this.$_invoke("adminUser_streetGetCommunity", {
        pid_ids: this.form_data.street_ids
      }).then((ret) => {
        // console.log(ret)
        this.community_list = ret.community_list;
      })
        .finally(() => {
          this.loading = false;
        });
    },

    //获取数据
    getData() {
      this.loading = true;
      if (this.hasId) {
        this.$_invoke("adminUser_getUpdateData", {
          id: this.$props.id,
          org_id: this.$props.org_id
        })
          .then((ret) => {
            // console.log(ret)
            this.community_list = ret.community_list;
            this.place_type_list = ret.place_type_list;
            this.street_list = ret.street_list;
            // this.role_highest_id = ret.role_highest_id;
            this.role_list = ret.role_list;
            this.form_data = ret.data;
            this.company_list = ret.company_list;

          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$_invoke("adminUser_getAddData", {
          org_id: this.$props.org_id
        })
          .then((ret) => {
            console.log(ret)
            this.role_list = ret.role_list;
            this.app_list = ret.app_list;
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },


    //生成随机密码
    randomWord() {
      this.form_data.pwd = randomWord(true, 6, 6);
    },

    //点击复制链接
    copy(e) {
      console.log(e.text);
      this.$_msg.success("复制成功");
    },

    //提交数据
    handleSubmit() {
      if (this.loading) return;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitting = true;
          if (!this.hasId) {
            //添加
            this.form_data.mobile = this.form_data.username;
            this.$_invoke("adminUser_save", this.form_data)
              .then(() => {
                this.$_msg.success("添加成功");
                this.$emit("on-success");
              })
              .finally(() => {
                this.submitting = false;
              });
          } else {
            //修改
            this.form_data.id = this.$props.id;
            this.form_data.mobile = this.form_data.username;
            this.$_invoke("adminUser_update", this.form_data)
              .then(() => {
                this.$_msg.success("修改成功");
                this.$emit("on-success");
              })
              .finally(() => {
                this.submitting = false;
              });
          }
        }
      });
    },
  },
};
</script>